export default "__VITE_ASSET__437a1680__"